var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19983 11.1928C10.7898 7.52363 16.5177 5.10467 19.3837 3.93595C27.5667 0.599007 29.2671 0.0193449 30.3753 0.000204084C30.6191 -0.00400572 31.1641 0.0552205 31.5171 0.336076C31.8152 0.573225 31.8973 0.89358 31.9365 1.11842C31.9758 1.34327 32.0246 1.85547 31.9858 2.25568C31.5423 6.8237 29.6236 17.9091 28.6474 23.0253C28.2344 25.1902 27.4211 25.9161 26.6337 25.9871C24.9226 26.1415 23.6232 24.8784 21.9659 23.8133C19.3725 22.1466 17.9074 21.1091 15.3901 19.4827C12.4809 17.6031 14.3668 16.57 16.0247 14.8817C16.4586 14.4399 23.9979 7.7166 24.1439 7.10669C24.1621 7.03041 24.1791 6.74607 24.0068 6.59594C23.8345 6.4458 23.5802 6.49714 23.3967 6.53797C23.1366 6.59585 18.9936 9.28057 10.9678 14.5921C9.79182 15.3838 8.72666 15.7696 7.77232 15.7494C6.72023 15.7271 4.69644 15.1661 3.19196 14.6867C1.34666 14.0986 -0.119957 13.7877 0.0077523 12.7889C0.074271 12.2687 0.804964 11.7367 2.19983 11.1928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d8add5832928b6a3d05ad44f4cec61f6.svg";
export { ForwardRef as ReactComponent };